import React from "react";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { RootStackParamList } from "../navigator";

import JoinTournamentModal from "../Components/Modals/JoinTournamentModal";

type Props = NativeStackScreenProps<RootStackParamList, "JoinTournaments">;

const JoinTournamentsScreen: React.FC<Props> = ({
  navigation,
  route: { params },
}) => {
  if (!params?.tournamentId) {
    navigation.goBack();
    return null;
  }

  const [isOpen, setIsOpen] = React.useState(true);

  return (
    isOpen && (
      <JoinTournamentModal
        onClose={() => setIsOpen(false)}
        tournamentId={params.tournamentId}
      />
    )
  );
};

export default JoinTournamentsScreen;
